module.exports = __webpack_public_path__ + "static/media/sharing-is-caring.f8d627f9.svg";